import type {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
} from "material-react-table";

export interface APIPaginatedTableState {
  columnFilters: MRT_ColumnFiltersState;
  pagination: MRT_PaginationState;
}

type APIPaginatedTableAction =
  | { type: "SET_COLUMN_FILTERS"; payload: MRT_ColumnFiltersState }
  | { type: "SET_PAGINATION"; payload: MRT_PaginationState }
  | { type: "RESET_TABLE" };

export const tableInitialState: APIPaginatedTableState = {
  columnFilters: [],
  pagination: {
    pageIndex: 0,
    pageSize: 15,
  },
};

export function tableReducer(
  state: APIPaginatedTableState,
  action: APIPaginatedTableAction
): APIPaginatedTableState {
  switch (action.type) {
    case "SET_COLUMN_FILTERS":
      return {
        ...state,
        columnFilters: action.payload,
      };

    case "SET_PAGINATION":
      return {
        ...state,
        pagination: action.payload,
      };
    case "RESET_TABLE":
      return tableInitialState;

    default:
      return state;
  }
}
